import { Languages } from 'lucide-react'
import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  useSidebar,
} from '@teach/ui'
import { useLanguage } from '@/hooks/useLanguage'
import { LanguageFlag } from './LanguageFlag'
import { useMessages } from '@/i18n'
import { messages } from './messages'

const LanguageOptions = () => {
  const { language, setLanguage } = useLanguage()
  return (
    <DropdownMenuRadioGroup
      value={language}
      onValueChange={(value) => setLanguage(value === 'en' ? 'en' : 'ru')}
    >
      <DropdownMenuRadioItem value="ru">
        <LanguageFlag lang="ru" className="mr-2" />
        Русский
      </DropdownMenuRadioItem>
      <DropdownMenuRadioItem value="en">
        <LanguageFlag lang="en" className="mr-2" />
        English
      </DropdownMenuRadioItem>
    </DropdownMenuRadioGroup>
  )
}

/** Пункт «Язык» меню профиля: текущий язык справа и подменю с флагами. На телефоне
 *  и планшете (меню — шторка во весь экран) подменю справа не помещалось и
 *  обрезалось краем — там языки стоят прямо в меню, под подписью «Язык». */
export const LanguageMenu = () => {
  const { language } = useLanguage()
  const { isMobile } = useSidebar()
  const m = useMessages(messages)
  if (isMobile) {
    return (
      <>
        <DropdownMenuLabel className="flex items-center text-xs font-normal text-muted-foreground">
          <Languages className="mr-2 size-4" />
          {m.language}
        </DropdownMenuLabel>
        <LanguageOptions />
      </>
    )
  }
  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Languages className="mr-2 size-4" />
        {m.language}
        <span className="mr-1 flex-1 text-right text-xs text-muted-foreground">
          {language === 'ru' ? 'Русский' : 'English'}
        </span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <LanguageOptions />
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
